import { FocusableElement } from '@front-app/hooks/useAsyncModal';

const FOCUSABLE_ELEMENTS_SELECTOR = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

export const getFocusableElements = (root: Element | Document = document): FocusableElement[] => Array.from(root.querySelectorAll(FOCUSABLE_ELEMENTS_SELECTOR));

export const getFirstFocusableElement = (root: Element | Document = document): FocusableElement | null => root.querySelector(FOCUSABLE_ELEMENTS_SELECTOR);
